import Lottie from 'react-lottie-player';
import lottieJson from './Preloader.json';
import './styles.scss';

const Preloader = () => {
    return (
        <Lottie
            loop
            animationData={lottieJson}
            play
            className="preloader"
            rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
        />
    );
};

export default Preloader;
